import { API_URL } from "env";
import { LeaderboardEntry } from ".";

interface LeaderboardAPIEntry {
    fullname: string;
    avatar: string;
    country: string | null;
    total_profit: number;
    current_balance: number;
    initial_balance: number;
    profit_percentage: number;
    rank: number;
}
const countryList = [
    { code: 'GB', name: 'United Kingdom' },
    { code: 'FR', name: 'France' },
    { code: 'KR', name: 'South Korea' },
    { code: 'US', name: 'United States' },
    { code: 'DE', name: 'Germany' },
    { code: 'JP', name: 'Japan' },
    { code: 'AU', name: 'Australia' },
    { code: 'CA', name: 'Canada' },
    { code: 'IT', name: 'Italy' },
    { code: 'ES', name: 'Spain' },
    { code: 'BR', name: 'Brazil' },
    { code: 'VN', name: 'Vietnam' },
    { code: 'IN', name: 'India' },
    { code: 'RU', name: 'Russia' },
    { code: 'ZA', name: 'South Africa' },
  ];

async function getLeaderBoardData(fillter_balance?: number) {
    try {
        const response = await fetch(API_URL + `/api/v1/be/13w-challenges/ranking${fillter_balance ? `?initial_balance=${fillter_balance}` : ''}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        });
        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            console.error("Failed to fetch leaderboard data:", response.statusText);
            return null;
        }
    }
    catch (error) {
        console.error("Error fetching leaderboard data:", error);
    }
}

async function LeaderBoardData(fillter_balance?: number): Promise<LeaderboardAPIEntry[]> {
    const data = await getLeaderBoardData(fillter_balance);
    if (data && data.success) {
        return data.data.map((item: any, index: number) => ({
            fullname: item.fullname,
            avatar: item.avatar,
            country: item.country,
            total_profit: item.total_profit,
            current_balance: item.current_balance,
            initial_balance: item.initial_balance,
            profit_percentage: item.profit_percentage,
            rank: index + 1,
        })) as LeaderboardAPIEntry[];
    }
    else if (data && !data.success) {
        throw new Error(data.message || "Failed to fetch leaderboard data");
    }
    else {
        throw new Error("No data received from server");
    }
}

async function fetchLeaderboard(fillter_balance?: number): Promise<LeaderboardEntry[]> {
    const leaderboardData = await LeaderBoardData(fillter_balance);

    const formatCurrency = (value: number) =>
        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(value);

    return leaderboardData.map((entry) => {
        const country = countryList.find(c => c.code === entry.country);
        return {
            rank: entry.rank,
            name: entry.fullname,
            country: country ? country.name : 'Unknown',
            countryCode: entry.country,
            profit: formatCurrency(entry.total_profit),
            equity: formatCurrency(entry.current_balance),
            achievedPercent: `${entry.profit_percentage}%`,
            accountSize: formatCurrency(entry.initial_balance),
            accountSizeValue: entry.initial_balance,
        } as LeaderboardEntry;
    });
}

export { LeaderBoardData ,fetchLeaderboard };
export type { LeaderboardAPIEntry };